// extracted by mini-css-extract-plugin
export default {"container":"Kn-z","bubbleNav":"Ln-z","graphic":"Mn-z","contact":"Nn-z"};